// FIXME: remove this file when we remove the old recently viewed hook
// These functions are used only for migration process, and should not be used on production in long term

import {
  MAX_RECENTLY_VIEWED_ITEMS,
  RECENTLY_VIEWED_KEY_V1,
  RECENTLY_VIEWED_KEY_V2,
  RECENTLY_VIEWED_KEY_V3,
  RecentlyViewedProductV1,
  RecentlyViewedProductV3,
} from '@/common/utils/recentlyViewed/recentlyViewed';
import { elysiumLogger } from '@/common/utils/sharedUtils';

// https://static.displate.com/280x392/displate/2022-03-01/c0fdf3f1a4d64158077febbc48b51d63_bbe43ed5e83e250aa553951cef6f1259.jpg
/**
 * Poor man's image path to core path converter. This is done on BFW, but we need it here to migrate the old data.
 * @param img full image path with 280x392 resolution
 * @returns image core path
 */
export const imgToCorePath = (img: string): string | undefined => {
  if (!img) {
    return undefined;
  }

  const corePath = img.replace('https://static.displate.com/280x392/displate/', '');
  if (corePath === img) {
    return undefined;
  }
  return corePath;
};

/**
 * Syncs the old recently viewed products to the new format.
 * The sync is only done once, when the user visits the new PDP for the first time.
 * We assume that once PDP is made public, any user that gets to see it, won't see the old PDP again. (this is how migration currently works)
 * @returns {void}
 */
export const syncV1ToV3 = (): RecentlyViewedProductV3[] => {
  if (localStorage.getItem(RECENTLY_VIEWED_KEY_V2)) {
    localStorage.removeItem(RECENTLY_VIEWED_KEY_V2);
  }

  const v3RawItems = localStorage.getItem(RECENTLY_VIEWED_KEY_V3);
  if (v3RawItems) {
    return JSON.parse(v3RawItems) as RecentlyViewedProductV3[];
  }

  const v1RawItems = localStorage.getItem(RECENTLY_VIEWED_KEY_V1);
  if (!v1RawItems) {
    return [];
  }

  let products: RecentlyViewedProductV1[] = [];
  try {
    products = JSON.parse(v1RawItems);
  } catch (e) {
    elysiumLogger().error('useRecentlyViewed V1 error', e);
    return [];
  }

  const productsV3 = products
    .reverse()
    .slice(0, MAX_RECENTLY_VIEWED_ITEMS)
    .map((product: RecentlyViewedProductV1): RecentlyViewedProductV3 => {
      return {
        id: parseInt(product.itemCollectionId),
        inId: product.id,
        orient: product.orientation,
        imgCore: imgToCorePath(product.image) ?? '',
        alt: product.title,
      };
    })
    .filter(
      (product: RecentlyViewedProductV3) =>
        product.id > 0 && product.inId > 0 && product.imgCore !== '',
    );

  localStorage.setItem(RECENTLY_VIEWED_KEY_V3, JSON.stringify(productsV3));
  return productsV3;
};
